import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { TokenService } from "../../services/token.service";

export const createSocketToken = createAsyncThunk(
  "tokenManage/createSocketToken",
  async (data, { rejectWithValue }) => {
    try {
      const response = await TokenService.createSocketToken(data);

      return _.get(response, "data", null);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const refreshSocketToken = createAsyncThunk(
  "tokenManage/refreshSocketToken",
  async (data, { rejectWithValue }) => {
    try {
      const response = await TokenService.refreshSocketToken(data);

      return _.get(response, "data", null);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
